import React from 'react';
import { FaBackspace } from 'react-icons/fa';
import styles from './OrderKeypad.module.css';

const OrderKeypad = ({ onInput, onBackspace }) => {
  const keypadLayout = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '0', 'backspace'];

  return (
    <div className={styles.orderKeypadContainer}>
      <div className={styles.keypadGrid}>
        {keypadLayout.map(key => {
          if (key === 'backspace') {
            return (
              <button key={key} onClick={onBackspace} className={styles.keypadButton}>
                <FaBackspace />
              </button>
            );
          }
          return (
            <button key={key} onClick={() => onInput(key)} className={styles.keypadButton}>
              {key}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default OrderKeypad;
